export default __webpack_public_path__ + "static/main-2417381f1dd483456043c2c2adc2cee2.gif";